import { colors } from 'styles/colors';
import { HealthVariant } from './components/UnitsInfo/types';
import { t } from 'i18next';

export function colorByHealthVariant(variant: HealthVariant): string {
  switch (variant) {
    case 'healthy': return colors.state.success.base;
    case 'alert': return colors.state.warning.base;
    case 'critical': return colors.state.danger.base;
    default: return colors.icon['soft-400'];
  }
}

export function hoverColorByHealthVariant(variant: HealthVariant): string {
  switch (variant) {
    case 'healthy': return colors.state.success.dark;
    case 'alert': return colors.state.warning.dark;
    case 'critical': return colors.state.danger.dark;
    default: return colors.icon['strong-800'];
  }
}

export function parseHealthVariantLabel(variant: HealthVariant): string {
  switch (variant) {
    case 'alert': return t('emAlertaSemiCritico');
    case 'critical': return t('critica');
    case 'healthy': return t('saudavel');
    default: return t('offline');
  }
}
